import { render, staticRenderFns } from "./SGroupProductsSaleComp.vue?vue&type=template&id=1e8da792&"
import script from "./SGroupProductsSaleComp.vue?vue&type=script&lang=js&"
export * from "./SGroupProductsSaleComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports